module.exports = ".whitecol {\n  background: #ffffff;\n  border: 1px solid #ffffff;\n  border-radius: 10px;\n  padding: 30px;\n  margin-top: 1em;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/gaming-platform/gaming-platform.component.css
// module id = ./src/app/components/gaming-platform/gaming-platform.component.css
// module chunks = main